/* AUTO-GENERATED FILE. DO NOT EDIT MANUALLY. */
/* Source: libs/laboratory/report-chat/src/components/report-chat-thread/translation/ru.json */
export const LABORATORY_REPORT_CHAT_TRANSLATION_SCHEME = {
  attachAria: 'laboratoryReportChat.attachAria',
  emptyHint: 'laboratoryReportChat.emptyHint',
  emptyTitle: 'laboratoryReportChat.emptyTitle',
  fileOpenAria: 'laboratoryReportChat.fileOpenAria',
  logAria: 'laboratoryReportChat.logAria',
  newMessages: 'laboratoryReportChat.newMessages',
  placeholder: 'laboratoryReportChat.placeholder',
  placeholderDisabled: 'laboratoryReportChat.placeholderDisabled',
  previewAria: 'laboratoryReportChat.previewAria',
  previewCloseAria: 'laboratoryReportChat.previewCloseAria',
  removeAttachmentAria: 'laboratoryReportChat.removeAttachmentAria',
  retry: 'laboratoryReportChat.retry',
  screenshotAria: 'laboratoryReportChat.screenshotAria',
  seen: 'laboratoryReportChat.seen',
  sendAria: 'laboratoryReportChat.sendAria',
  sendFailed: 'laboratoryReportChat.sendFailed',
  sending: 'laboratoryReportChat.sending',
  student: 'laboratoryReportChat.student',
  supportName: 'laboratoryReportChat.supportName',
  today: 'laboratoryReportChat.today',
  yesterday: 'laboratoryReportChat.yesterday',
  you: 'laboratoryReportChat.you',
  tsScope: 'laboratoryReportChat',
} as const;
